/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cardr": {
        "nested": {
          "issuing": {
            "nested": {
              "DigitalWalletProvisionApplePayRequest": {
                "fields": {
                  "certificates": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "nonce": {
                    "type": "bytes",
                    "id": 2,
                    "rule": "optional"
                  },
                  "nonceSignature": {
                    "type": "bytes",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "DigitalWalletProvisionApplePayResponse": {
                "fields": {
                  "encryptedPassData": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  },
                  "activationData": {
                    "type": "bytes",
                    "id": 2,
                    "rule": "optional"
                  },
                  "ephemeralPublicKey": {
                    "type": "bytes",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.DigitalWalletProvisionApplePayRequest && !$root.nested?.squareup?.nested?.cardr?.nested?.issuing?.nested?.DigitalWalletProvisionApplePayResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DigitalWalletProvisionApplePayRequest @ squareup/cardr/issuing/digital_wallet_configuration.proto at 11:1
 */
export const DigitalWalletProvisionApplePayRequest = $root.lookupType('squareup.cardr.issuing.DigitalWalletProvisionApplePayRequest');
fixType(DigitalWalletProvisionApplePayRequest);
Builder.createAndAttachToType(DigitalWalletProvisionApplePayRequest);
/**
 * SOURCE DigitalWalletProvisionApplePayResponse @ squareup/cardr/issuing/digital_wallet_configuration.proto at 20:1
 */
export const DigitalWalletProvisionApplePayResponse = $root.lookupType('squareup.cardr.issuing.DigitalWalletProvisionApplePayResponse');
fixType(DigitalWalletProvisionApplePayResponse);
Builder.createAndAttachToType(DigitalWalletProvisionApplePayResponse);